import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ModalController, Events } from '@ionic/angular';
import { ChatBotPage } from '../../chat-bot/chat-bot.page';
import { UserService } from 'src/app/services/user/user.service';
import { HomePage } from "../../home/home.page";
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Storage } from '@ionic/storage';
@Component({
    selector: 'app-chat-modal',
    templateUrl: './chat-modal.component.html',
    styleUrls: ['./chat-modal.component.scss'],
})
export class ChatModalComponent implements OnInit {
    isChatModalOpen;
    message = 'this is child message';
    unreadAdminMsgs: number = 0;
    @Output() clickEvent = new EventEmitter<boolean>();

    constructor(private modalController: ModalController,
        private events: Events,
        private utilsService: UtilsService,
        public userService: UserService,
        private storage: Storage) { }

    async ngOnInit() {
        this.initializeSubscriptions();
        const userId = await this.storage.get('uid');
        if (userId) {
            this.events.publish('chat:getUnreadMsgOfAdmin', userId);
        }
    }

    initializeSubscriptions() {
        this.events.subscribe('makeUnreadAdminMsgsZero', () => {
            this.unreadAdminMsgs = 0;
        });

        this.events.subscribe('chat:publishUnreadMsgOfAdmin', (unreadMsgs) => {
            this.unreadAdminMsgs = unreadMsgs <= 99 ? unreadMsgs : '99+';
        });
    }

    ngOnDestroy() {
        this.events.unsubscribe('makeUnreadAdminMsgsZero');
        this.events.unsubscribe('makeUnreadAdminMsgsZero');
    }

    openChat() {
        if (this.userService.userId != '') {
            this.openChatModal();
        } else {
            this.openLoginModal();
        }

    }

    async openLoginModal() {
        this.utilsService.openLoginModal()
    }

    async openChatModal() {
        const modal = await this.modalController.create({
            component: ChatBotPage,
            cssClass: "chat-modal",
            showBackdrop: false,
            backdropDismiss: false
        });
        return await modal.present();

    }

}
